import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';

import { ValueBox, ValueGroup, ValueInput } from '@candu-ai/craft/ui';

interface Props {
  placeholder: string | undefined;
  setProps: (props: Record<string, any>) => void;
  inputNamePrefix?: string;
}

export const PlaceholderText = ({
  placeholder,
  setProps,
  inputNamePrefix = 'form-input',
}: Props) => {
  const [inputProps, setInputProps] = useState<{ placeholder?: string }>({ placeholder });

  useEffect(() => {
    setInputProps({ placeholder });
  }, [placeholder]);

  const onInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setProps({ placeholder: value });
      setInputProps({ placeholder: value });
    },
    [setProps, setInputProps],
  );

  return (
    <ValueGroup>
      <ValueBox label="Placeholder">
        <ValueInput
          value={inputProps.placeholder}
          name={`${inputNamePrefix}-placeholder-value`}
          onChange={onInputChange}
          placeholder="Placeholder"
        />
      </ValueBox>
    </ValueGroup>
  );
};
